import React from 'react';

export default function KnotWatermark({ position = 'center', className = '' }) {
  const positions = {
    center: 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    'top-right': 'right-0 top-0 translate-x-1/4 -translate-y-1/4',
    'bottom-left': 'left-0 bottom-0 -translate-x-1/4 translate-y-1/4',
  };

  return (
    <img
      src="/assets/inerva-knot.png"
      alt=""
      aria-hidden="true"
      className={`absolute pointer-events-none opacity-5 w-96 h-auto ${positions[position]} ${className}`}
    />
  );
}
